// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1cI3Y","header":"ReportDetails_header__1Xvv7","title":"ReportDetails_title__3o4ug","left":"ReportDetails_left__2vF0T"};